module.exports = __webpack_public_path__ + "img/tM_bg.9dd2079.png";